import { CategoriesState } from '../categories/types'

export const GET_CATEGORIES_EARN_PUBLIC = 'GET_CATEGORIES_EARN_PUBLIC'
export const GET_CATEGORIES_EARN_PUBLIC_SUCCESS = 'GET_CATEGORIES_EARN_PUBLIC_SUCCESS'
export const GET_CATEGORIES_EARN_PUBLIC_FAILURE = 'GET_CATEGORIES_EARN_PUBLIC_FAILURE'

export type CategoriesEarnPublicState = CategoriesState
